module.exports = __webpack_public_path__ + "img/ken-suarez-oO7d1Q9mJZQ-unsplash@2x.bd3a8488.png";